


<template>
  <div class="page">
    <HeaderTemplate />
  <main> <router-view /> </main>
  <FooterTemplate/>

</div>

</template>

<script>
import HeaderTemplate from './components/HeaderTemplate.vue';
import FooterTemplate from '@/components/FooterTemplate.vue';

export default {
  name: 'App',
  components: {
    HeaderTemplate,
    FooterTemplate

  }
};
</script>
<style lang="scss">
@import './assets/style/index.scss';
@import './assets/style/mixins.scss';

</style> 